import { useState } from "react";
import { FaUserShield, FaKey, FaCopy, FaCheckCircle } from "react-icons/fa";
import Modal from "../modal/modal";
import { toast } from "react-toastify";
import { resetUserPassword } from "../services/userservice";

const ResetPasswordModal = ({ target, onClose }) => {
  const [newPassword, setNewPassword] = useState("");
  const [notifyUser, setNotifyUser]   = useState(true);
  const [resetting, setResetting]     = useState(false);
  const [resetResult, setResetResult] = useState(null);

  const handleResetPassword = async () => {
    setResetting(true);
    try {
      const payload = { new_password: newPassword.trim() || "", notify_user: notifyUser };
      const res = await resetUserPassword(target.id, payload);
      const returnedPw = res.new_password || payload.new_password;
      setResetResult({ email: target.email, password: returnedPw || "Sent via Email" });
      toast.success(res.message || "Password successfully reset");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to reset password");
    } finally {
      setResetting(false);
    }
  };

  return (
    <Modal title="Reset User Password" onClose={onClose}>
      {resetResult ? (
        <div className="employee-modal-success">
          <div className="success-icon"><FaCheckCircle /></div>
          <h4>Password Successfully Reset!</h4>
          <p>The password for <strong>{resetResult.email}</strong> has been reset.</p>
          <div className="password-display-premium" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <code>{resetResult.password}</code>
            <button className="icon-btn edit" title="Copy Password" onClick={() => { navigator.clipboard.writeText(resetResult.password); toast.success("Password copied to clipboard!"); }}>
              <FaCopy />
            </button>
          </div>
          <button className="primary" onClick={onClose} style={{ width: "100%" }}>Done</button>
        </div>
      ) : (
        <>
          <div className="employee-form-modal-body">
            <div className="form-section-card">
              <div className="section-title-premium"><FaUserShield /> Account</div>
              <div className="account-readout">
                Resetting credentials for account: <strong>{target.email}</strong>
              </div>
            </div>

            <div className="form-section-card">
              <div className="section-title-premium"><FaKey /> New Password</div>
              <input type="text" placeholder="Leave blank to auto-generate secure password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
              <small style={{ color: "var(--text-muted)", fontSize: "12px", display: "block", marginTop: "8px" }}>
                Min 8 characters. If blank, a random 12-char secure password is generated.
              </small>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "16px" }}>
                <input type="checkbox" id="notifyUserCheckbox" checked={notifyUser} onChange={(e) => setNotifyUser(e.target.checked)} style={{ width: "16px", height: "16px", cursor: "pointer" }} />
                <label htmlFor="notifyUserCheckbox" style={{ fontSize: "13px", color: "var(--text-main)", cursor: "pointer" }}>
                  Send email notification to user
                </label>
              </div>
            </div>
          </div>

          <div className="premium-modal-footer">
            <button className="user-secondary" onClick={onClose} disabled={resetting}>Cancel</button>
            <button className="primary" onClick={handleResetPassword} disabled={resetting}>{resetting ? "Resetting…" : "Reset Password"}</button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ResetPasswordModal;